// extracted by mini-css-extract-plugin
module.exports = {"dialogButtons":"StartConfirmationPopup_dialogButtons__1xL5B","cancelButton":"StartConfirmationPopup_cancelButton__183Ko"};